import { isDevMode } from '@angular/core';
import {
  ActionReducerMap,
  MetaReducer
} from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ContactDetailsEffects } from './effects/contact-details/contact-details.effects';
import { ClinicianDetailsEffects } from './effects/clinician-details/clinician-details.effects';
import { TaxIdentificationNumberDetailsEffects } from './effects/tax-identification-number-details/tax-identification-number-details.effects';
import { AddOrganizationEffects } from './effects/add-organization/add-organization.effects';
import { UserAdminEffects } from './effects/user-admin/user-admin.effects';
import { OrganizationAdminEffects } from './effects/organization-admin/organization-admin.effects';
import { UserEffects } from './effects/user/user.effects';
import { AuthEffects } from './effects/auth/auth.effects';
import { IdleEffects } from './effects/idle/idle.effects';
import { TopbarEffects } from './effects/topbar/topbar.effects';
import { MeasuresEffects } from './effects/measures/measures.effects';
import { OrganizationEMRDetailsEffects } from './effects/organization-emr-details/organization-emr-details.effects';
import { OrgSupplementalSystemEffects } from './effects/org-supplemental-system/org-supplemental-system.effects';
import { AgreementEffects } from './effects/agreement/agreement.effects';
import { DocusignEffects } from './effects/docusign/docusign.effects';
import { DashboardEffects } from './effects/dashboard/dashboard.effects';
import { IssueTrackerEffects } from './effects/issue-tracker/issue-tracker.effects';
import { PowerBIEffects } from './effects/power-bi/power-bi.effects';
import { MipsQuestionnaireEffects } from './effects/mips-questionnaire/mips-questionnaire.effects';
import { MipsEligibilityEffects } from './effects/mips-eligibility/mips-eligibility.effects';
import { MipsPacketEffects } from './effects/mips-packet/mips-packet.effects'
import { MipsFileRepositoryEffects } from './effects/mips-file-repository/mips-file-repository.effects';
import { MeetingNotesEffects } from './effects/meeting-notes/meeting-notes.effects';
import { NotificationsEffects } from './effects/notifications/notifications.effects';
import { ReportingEffects } from './effects/reporting/reporting.effects';
import { EmrEffects } from './effects/emr/emr.effects';
import { MipsSubmissionBlockEffects } from './effects/mips-submission-block/mips-submission-block.effects';
import { ReviewBoardEffects } from './effects/review-board/review-board.effects';
import { QualityMeasureSurveyEffects } from './effects/quality-measure-survey/quality-measure-survey.effects';

import * as fromAddOrganization from './reducers/add-organization/add-organization.reducer';
import * as fromContactDetails from './reducers/contact-details/contact-details.reducer';
import * as fromClinicianDetails from './reducers/clinician-details/clinician-details.reducer'
import * as fromTaxIdentificationNumberDetails from './reducers/tax-identification-number-details/tax-identification-number-details.reducer';
import * as fromUserAdmin from '@store/reducers/user-admin/user-admin.reducer';
import * as fromOrganizationAdmin from './reducers/organization-admin/organization-admin.reducer';
import * as fromUser from './reducers/user/user.reducer';
import * as fromAuth from './reducers/auth/auth.reducer';
import * as fromIdle from './reducers/idle/idle.reducer';
import * as fromTopbar from './reducers/topbar/topbar.reducer';
import * as fromMeasures from './reducers/measures/measures.reducer';
import * as fromOrganizationEMRDetails from './reducers/organization-emr-details/organization-emr-details.reducer';
import * as fromOrgSupplementalSystem from './reducers/org-supplemental-system/org-supplemental-system.reducer';
import * as fromAgreement from './reducers/agreement/agreement.reducer';
import * as fromDocusign from './reducers/docusign/docusign.reducer';
import * as fromDashboard from './reducers/dashboard/dashboard.reducer';
import * as fromPowerBI from './reducers/power-bi/power-bi.reducer';
import * as fromIssueTracker from './reducers/issue-tracker/issue-tracker.reducer';
import * as fromMipsQuestionnaire from './reducers/mips-questionnaire/mips-questionnaire.reducer';
import * as fromMipsEligibility from './reducers/mips-eligibility/mips-eligibility.reducer';
import * as fromMipsPacket from './reducers/mips-packet/mips-packet.reducer';
import * as fromMipsFileRepository from './reducers/mips-file-repository/mips-file-repository.reducer';
import * as fromMeetingNotes from './reducers/meeting-notes/meeting-notes.reducer';
import * as fromNotifications from './reducers/notifications/notifications.reducer';
import * as fromReporting from './reducers/reporting/reporting.reducer';
import * as fromEmr from './reducers/emr/emr.reducer';
import * as fromMipsSubmissionBlock from './reducers/mips-submission-block/mips-submission-block.reducer';
import * as fromReviewBoard from './reducers/review-board/review-board.reducer';
import * as fromQualityMeasureSurvey from './reducers/quality-measure-survey/quality-measure-survey.reducer';




export interface State {

  router: RouterReducerState<any>;
  [fromAddOrganization.addOrganizationFeatureKey]: fromAddOrganization.State;
  [fromContactDetails.contactDetailsFeatureKey]: fromContactDetails.State;
  [fromClinicianDetails.clinicianDetailsFeatureKey]: fromClinicianDetails.State;
  [fromTaxIdentificationNumberDetails.taxIdentificationNumberDetailsFeatureKey]: fromTaxIdentificationNumberDetails.State;
  [fromUserAdmin.userAdminFeatureKey]: fromUserAdmin.State;
  [fromOrganizationAdmin.organizationAdminFeatureKey]: fromOrganizationAdmin.State;
  [fromUser.userFeatureKey]: fromUser.State;
  [fromAuth.authFeatureKey]: fromAuth.State;
  [fromIdle.idleFeatureKey]: fromIdle.State;
  [fromTopbar.topbarFeatureKey]: fromTopbar.State;
  [fromMeasures.measuresFeatureKey] : fromMeasures.State;
  [fromOrganizationEMRDetails.organizationEMRDetailsFeatureKey] : fromOrganizationEMRDetails.State;
  [fromOrgSupplementalSystem.orgSupplementalSystemFeatureKey]: fromOrgSupplementalSystem.State;
  [fromAgreement.agreementFeatureKey]: fromAgreement.State;
  [fromDocusign.docusignFeatureKey]: fromDocusign.State;
  [fromDashboard.dashboardFeatureKey]: fromDashboard.State;
  [fromPowerBI.powerBIFeatureKey]: fromPowerBI.State;
  [fromIssueTracker.issueTrackerFeatureKey]: fromIssueTracker.State;
  [fromMipsQuestionnaire.mipsQuestionnaireFeatureKey]: fromMipsQuestionnaire.State;
  [fromMipsEligibility.mipsEligibilityFeatureKey]: fromMipsEligibility.State;
  [fromMipsPacket.mipsPacketFeatureKey]: fromMipsPacket.State;
  [fromMipsFileRepository.mipsFileRepositoryFeatureKey]: fromMipsFileRepository.State;
  [fromMeetingNotes.meetingNotesFeatureKey]: fromMeetingNotes.State;
  [fromNotifications.notificationsFeatureKey]: fromNotifications.State;
  [fromReporting.reportingFeatureKey]: fromReporting.State;
  [fromEmr.emrFeatureKey]: fromEmr.State;
  [fromMipsSubmissionBlock.mipsSubmissionBlockFeatureKey]: fromMipsSubmissionBlock.State;
  [fromReviewBoard.reviewBoardFeatureKey]: fromReviewBoard.State;
  [fromQualityMeasureSurvey.qualityMeasureSurveyFeatureKey]: fromQualityMeasureSurvey.State;
}

export const reducers: ActionReducerMap<State> = {
  router: routerReducer,
  [fromAddOrganization.addOrganizationFeatureKey]: fromAddOrganization.reducer,
  [fromContactDetails.contactDetailsFeatureKey]: fromContactDetails.reducer,
  [fromClinicianDetails.clinicianDetailsFeatureKey]: fromClinicianDetails.reducer,
  [fromTaxIdentificationNumberDetails.taxIdentificationNumberDetailsFeatureKey]: fromTaxIdentificationNumberDetails.reducer,
  [fromUserAdmin.userAdminFeatureKey]: fromUserAdmin.reducer,
  [fromOrganizationAdmin.organizationAdminFeatureKey]: fromOrganizationAdmin.reducer,
  [fromUser.userFeatureKey]: fromUser.reducer,
  [fromAuth.authFeatureKey]: fromAuth.reducer,
  [fromIdle.idleFeatureKey]: fromIdle.reducer,
  [fromTopbar.topbarFeatureKey]: fromTopbar.reducer,
  [fromMeasures.measuresFeatureKey] : fromMeasures.reducer,
  [fromOrganizationEMRDetails.organizationEMRDetailsFeatureKey] : fromOrganizationEMRDetails.reducer,
  [fromOrgSupplementalSystem.orgSupplementalSystemFeatureKey]: fromOrgSupplementalSystem.reducer,
  [fromAgreement.agreementFeatureKey]: fromAgreement.reducer,
  [fromDocusign.docusignFeatureKey]: fromDocusign.reducer,
  [fromDashboard.dashboardFeatureKey]: fromDashboard.reducer,
  [fromPowerBI.powerBIFeatureKey]: fromPowerBI.reducer,
  [fromIssueTracker.issueTrackerFeatureKey]: fromIssueTracker.reducer,
  [fromMipsQuestionnaire.mipsQuestionnaireFeatureKey]: fromMipsQuestionnaire.reducer,
  [fromMipsEligibility.mipsEligibilityFeatureKey]: fromMipsEligibility.reducer,
  [fromMipsPacket.mipsPacketFeatureKey]: fromMipsPacket.reducer,
  [fromMipsFileRepository.mipsFileRepositoryFeatureKey]: fromMipsFileRepository.reducer,
  [fromMeetingNotes.meetingNotesFeatureKey]: fromMeetingNotes.reducer,
  [fromNotifications.notificationsFeatureKey]: fromNotifications.reducer,
  [fromReporting.reportingFeatureKey]: fromReporting.reducer,
  [fromEmr.emrFeatureKey]: fromEmr.reducer,
  [fromMipsSubmissionBlock.mipsSubmissionBlockFeatureKey]: fromMipsSubmissionBlock.reducer,
  [fromReviewBoard.reviewBoardFeatureKey]: fromReviewBoard.reducer,
  [fromQualityMeasureSurvey.qualityMeasureSurveyFeatureKey]: fromQualityMeasureSurvey.reducer,
};


export const metaReducers: MetaReducer<State>[] = isDevMode() ? [] : [];


export const effects = [
  ContactDetailsEffects,
  ClinicianDetailsEffects,
  TaxIdentificationNumberDetailsEffects,
  AddOrganizationEffects,
  UserAdminEffects,
  OrganizationAdminEffects,
  UserEffects,
  AuthEffects,
  IdleEffects,
  MeasuresEffects,
  OrganizationEMRDetailsEffects,
  OrgSupplementalSystemEffects,
  TopbarEffects,
  AgreementEffects,
  DocusignEffects,
  DashboardEffects,
  PowerBIEffects,
  IssueTrackerEffects,
  MipsQuestionnaireEffects,
  MipsEligibilityEffects,
  MipsPacketEffects,
  MipsFileRepositoryEffects,
  MeetingNotesEffects,
  NotificationsEffects,
  ReportingEffects,
  EmrEffects,
  MipsSubmissionBlockEffects,
  ReviewBoardEffects,
  QualityMeasureSurveyEffects,
];
